import { User } from "~/common/Store/models/User";
import shouldDisplayBelowMapPrice from "./shouldDisplayBelowMapPrice";
import { LowestPricingProduct } from "./getLowestDisplayPrice";

export default (product: LowestPricingProduct, user: User): boolean => {
  const {
    price: { minimumAdvertisedPriceProperties, displayMinimumAdvertisedPrice },
  } = product;

  const hasMapStyle = !!minimumAdvertisedPriceProperties?.type?.trim();

  if (!hasMapStyle || !displayMinimumAdvertisedPrice) {
    return false;
  }

  const displayBelowMapPrice = shouldDisplayBelowMapPrice(product, user);

  return !displayBelowMapPrice;
};
